import { type PaymentRead, type VisitScheduleItem } from "@/api-v3";

export {
  getAdminConfirmedVisit,
  getConfirmedVisitDate,
  isVisitConfirmed,
} from "@nmible-ltd/claims";

/** All payments across every participant visit recorded against the template. */
export const getVisitPayments = (visit: VisitScheduleItem): PaymentRead[] =>
  visit.participant_visits?.flatMap(
    (participantVisit) => participantVisit.payments ?? []
  ) ?? [];
